import { render } from "./RatesPage.vue?vue&type=template&id=60eab3af"
import script from "./RatesPage.vue?vue&type=script&lang=js"
export * from "./RatesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__